<template>
	<div class="layout-topbar">
		<button v-if="layoutMode === 'horizontal'" class="p-link topbar-logo">
			<img alt="logo" src="assets/layout/images/logo-slim.png"/>
			<span class="app-name">OTTHONÁPOLÓ</span>
		</button>

		<img alt="logo" src="assets/layout/images/logo-slim.png" class="mobile-logo"/>

		<button class="p-link menu-btn" @click="onMenuButtonClick">
			<i class="pi pi-bars"></i>
		</button>

		<button class="p-link topbar-menu-btn" @click="onTopbarMobileMenuButtonClick">
			<i class="pi pi-user"></i>
		</button>

		<div class="layout-topbar-menu-wrapper">
			<ul :class="topbarMenuClass">
				<!--li :class="[{'active-topmenuitem': activeTopbarItem === 'profile'}]">
					<button class="p-link" @click="onTopbarItemClick($event, 'profile')">
						<span class="profile-image-wrapper">
                            <span :data-letters="UserNameLetters"></span>
						</span>
						<span class="topbar-item-name profile-name">{{ UserName }}<br/>{{ UserRoleName }}</span>
					</button>
					<transition name="layout-submenu-container">
						<ul class="fadeInDown" v-show="activeTopbarItem === 'profile'">
							<li role="menuitem">
								<button class="p-link" @click="linkProfil">
									<i class="pi pi-user"></i>
									<span>Profil</span>
								</button>
							</li>
							<li role="menuitem">
								<button class="p-link" @click="signOut">
									<i class="pi pi-sign-out"></i>
									<span>Kilépés</span>
								</button>
							</li>
						</ul>
					</transition>
				</li>
				<li :class="[{'active-topmenuitem': activeTopbarItem === 'settings'}]">
					<button class="p-link" @click="onTopbarItemClick($event, 'settings')">
						<i class="topbar-icon pi pi-cog"></i>
						<span class="topbar-item-name">Settings</span>
					</button>
					<transition name="layout-submenu-container">
						<ul class="fadeInDown" v-show="activeTopbarItem === 'settings'">
							<li role="menuitem">
								<button class="p-link">
									<i class="pi pi-palette"></i>
									<span>Change Theme</span>
								</button>
							</li>
							<li role="menuitem">
								<button class="p-link">
									<i class="pi pi-heart"></i>
									<span>Favorites</span>
								</button>
							</li>
							<li role="menuitem">
								<button class="p-link">
									<i class="pi pi-lock"></i>
									<span>Lock Screen</span>
								</button>
							</li>
							<li role="menuitem">
								<button class="p-link">
									<i class="pi pi-image"></i>
									<span>Wallpaper</span>
								</button>
							</li>
						</ul>
					</transition>
				</li>
				<li :class="[{'active-topmenuitem': activeTopbarItem === 'messages'}]">
					<button class="p-link" @click="onTopbarItemClick($event, 'messages')">
						<i class="topbar-icon pi pi-envelope animated swing"></i>
						<span class="topbar-badge animated rubberBand">5</span>
						<span class="topbar-item-name">Messages</span>
					</button>

					<transition name="layout-submenu-container">
						<ul class="fadeInDown" v-show="activeTopbarItem === 'messages'">
							<li role="menuitem">
								<button class="topbar-message p-link">
									<img src="assets/layout/images/avatar1.png" width="35" alt="avatar1"/>
									<span>Give me a call</span>
								</button>
							</li>
							<li role="menuitem">
								<button class="topbar-message p-link">
									<img src="assets/layout/images/avatar2.png" width="35" alt="avatar2"/>
									<span>Sales reports attached</span>
								</button>
							</li>
							<li role="menuitem">
								<button class="topbar-message p-link">
									<img src="assets/layout/images/avatar3.png" width="35" alt="avatar3"/>
									<span>About your invoice</span>
								</button>
							</li>
							<li role="menuitem">
								<button class="topbar-message p-link">
									<img src="assets/layout/images/avatar2.png" width="35" alt="avatar2"/>
									<span>Meeting today at 10pm</span>
								</button>
							</li>
							<li role="menuitem">
								<button class="topbar-message p-link">
									<img src="assets/layout/images/avatar4.png" width="35" alt="avatar4"/>
									<span>Out of office</span>
								</button>
							</li>
						</ul>
					</transition>
				</li>
				<li :class="[{'active-topmenuitem': activeTopbarItem === 'notifications'}]">
					<button class="p-link" @click="onTopbarItemClick($event, 'notifications')">
						<i class="topbar-icon pi pi-bell"></i>
						<span class="topbar-badge animated rubberBand">4</span>
						<span class="topbar-item-name">Notifications</span>
					</button>
					<transition name="layout-submenu-container">
						<ul class="fadeInDown" v-show="activeTopbarItem === 'notifications'">
							<li role="menuitem">
								<button class="p-link">
									<i class="pi pi-sliders-h"></i>
									<span>Pending tasks</span>
								</button>
							</li>
							<li role="menuitem">
								<button class="p-link">
									<i class="pi pi-calendar"></i>
									<span>Meeting today at 3pm</span>
								</button>
							</li>
							<li role="menuitem">
								<button class="p-link">
									<i class="pi pi-download"></i>
									<span>Download documents</span>
								</button>
							</li>
							<li role="menuitem">
								<button class="p-link">
									<i class="pi pi-ticket"></i>
									<span>Book flight</span>
								</button>
							</li>
						</ul>
					</transition>
				</li>
				<li :class="['search-item', {'active-topmenuitem': activeTopbarItem === 'search'}]"
					@click="onTopbarItemClick($event, 'search')">
					<span class="p-float-label p-input-icon-left">
						<i class="topbar-icon pi pi-search"></i>
						<InputText id="search" type="text" v-model="searchText" placeholder="Search"/>
					</span>
				</li-->
			</ul>
		</div>
	</div>
</template>

<script>
    import { UserService } from '@/service/backend/user.service';
    import { mapGetters } from 'vuex'
    import router from '@/router'

	export default {
		data() {
			return {
				searchText: ''
			}
		},
		emits: ['menu-button-click', 'topbar-mobile-menu-button-click', 'topbar-item-click'],
		props: {
			layoutMode: String,
			activeTopbarItem: String,
			topbarMenuActive: Boolean
		},
		methods: {
			onMenuButtonClick(event) {
				this.$emit('menu-button-click', event);
			},
			onTopbarMobileMenuButtonClick(event) {
				this.$emit('topbar-mobile-menu-button-click', event);
			},
			onTopbarItemClick(event, item) {
				this.$emit('topbar-item-click', {originalEvent: event, item: item});
			},
            linkProfil(){
                router.push({ name: 'profile'})
            },
            signOut() {
                UserService.logout()
            }
		},
		computed: {
            ...mapGetters({
                UserName:        'user/UserName',
                UserRoleName:    'user/UserRoleName',
                UserNameLetters: 'user/UserNameLetters'
            }),
			topbarMenuClass() {
				return ['topbar-menu fadeInDown', {
					'topbar-menu-active': this.topbarMenuActive
				}];
			}
		}
	}
</script>
<style scoped>
[data-letters]:before {
  content:attr(data-letters);
  display:inline-block;
  font-size:1em;
  width:2.8em;
  height:2.8em;
  line-height:2.8em;
  text-align:center;
  border-radius:50%;
  background:darkslateblue;
  vertical-align:middle;
  color:white;
  margin-top: -5px;
}

.layout-topbar {
    height: 12px !important;
    padding: 0px !important;
}

@media only screen and (max-width: 1024px) {
    .layout-topbar {
        height: 34px !important;
        padding: 0px !important;
    }
    .menu-btn {
        margin-left: 8px !important;
    }

    .mobile-logo, .topbar-menu-btn {
        display: none !important;
    }
}

</style>